const backgroundImageMaxHeightInPx = 600;
const canvas = "_35sc75bw9t";
const inputs = "_35si1mt4329";
const background = "_35sbz290s9";

export { background, backgroundImageMaxHeightInPx, canvas, inputs };
import "./organism.canvas.style.linaria.module.css";
//# sourceMappingURL=organism.canvas.style.js.map
